import React from 'react';
import { Link } from 'react-router-dom';
import { useBranding } from '../context/BrandingContext';
import '../styles/login.css'; // Reuse the excellent responsive container logic

function NotFound() {
  const { branding } = useBranding();
  
  const logoSrc = branding?.logoUrl;
  const accent = branding?.colors?.accent || '#E65C00';
  const companyName = branding?.companyName || 'Sistem';

  return (
    <div className="login-page-wrapper">
      <div className="login-container shadow-sm" style={{ maxWidth: '500px', width: '90%' }}>
        <div className="login-form-panel w-100" style={{ borderRight: 'none', borderRadius: '24px' }}>
          <div className="login-form-inner text-center py-5">
            
            {/* Dynamic Logo */}
            <div className="mb-4">
              {logoSrc ? (
                <img 
                  src={logoSrc} 
                  alt={companyName} 
                  style={{ height: '60px', objectFit: 'contain' }} 
                />
              ) : (
                <div style={{ fontSize: '24px', fontWeight: 'bold', color: accent }}>
                  {companyName}
                </div>
              )}
            </div>

            <h1 className="display-1 fw-bold mb-3" style={{ color: accent }}>404</h1>
            <h3 className="mb-3" style={{ color: '#1e293b' }}>Sayfa Bulunamadı</h3>
            <p className="text-muted mb-4" style={{ fontSize: '15px' }}>
              Aradığınız sayfa bulunamadı veya taşınmış olabilir.
            </p>
            
            <Link 
              to="/" 
              className="login-btn mt-2" 
              style={{ backgroundColor: accent, textDecoration: 'none', display: 'inline-block' }}
            >
              <i className="fas fa-home me-2"></i>
              Ana Sayfaya Dön
            </Link>
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;